import { openCookieSettings } from "@/lib/cookieConsent";
import { cn } from "@/lib/utils";

/**
 * Reopens the preferences modal. `data-cc` is the hook vanilla-cookieconsent
 * binds; the click handler covers the moment before that listener exists.
 */
export function CookieSettingsButton({
    className,
    children = "Cookie settings",
}: {
    className?: string;
    children?: React.ReactNode;
}) {
    return (
        <button
            type="button"
            data-cc="show-preferencesModal"
            className={cn("underline underline-offset-4", className)}
            onClick={() => openCookieSettings()}
        >
            {children}
        </button>
    );
}
